import React from 'react';
import cs from 'classnames';
import {push as pushPath} from 'react-router-redux';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import HeadText from './HeadText';
import SearchForm from '../searchform/searchform';
import RecentSearches from '../RecentSearches';
import StateList from '../common/StateList';
import mapDispatch from '~/misc/mapDispatch';
import * as modes from '~/modules/modal/modes';
import {modalChange} from '~/modules/modal/actions';
import {getUrlQeury} from '~/misc/formatUrlquery';
import UpgradeEntrance from '~/pages/MembershipPlans/components/UpgradeEntrance'

import css from './index.css';
import sharedCSS from '../shared.css';
import { CommandSwiper } from '../CommandSwiper';


const randomShowPop = (data) => {
  const {user, emailPopSwitch, emailPopRate} = data;
  // service close switch close verify pop
  if (!emailPopSwitch) {
    return false;
  }

  // profile msg incomplete
  if (user.emailVerified && user.firstName && user.lastName && user.phone
      && (user.verify_result)
  ) {
    return false;
  }

  // random open verify pop rate
  const randow1 = Math.round(Math.random() * 100);
  return randow1 < emailPopRate;
};

const judgeMember = (accountLevel, free) => {
  if (parseInt(accountLevel) > parseInt(free)) {
    return true;
  }
  return false;
};

const navigate = (e, props) => {
  e.preventDefault();
  const {
    isLoggedIn,
    emailPopSwitch,
    accountLevel,
    free,
  } = props;
  const openPop = randomShowPop(props);

  // limit broker jump func
  if (e.target.innerHTML === 'Brokers') {
    // not login
    if (emailPopSwitch && !isLoggedIn) {
      return props.login();
    }

    // not a member user
    if (!judgeMember(accountLevel, free)) {
      return props.showUpgradeToStandard();
    }

    // open verify pop
    if (openPop) {
      return props.showDownloadAppAndSendEmail();
    }
    return props.gotoBrokers(e.currentTarget.getAttribute('href'));
  }
  // return props.gotoDirections(e.currentTarget.getAttribute('href'));
  return window.location.href = `${location.protocol}//${location.host}${e.currentTarget.getAttribute('href')}`;
};

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const query = getUrlQeury();
    if (!isEmpty(query) && query.sign_up_pop) {
      this.props.signup();
    }
  }

  render() {
    return (
      <div className={cs(sharedCSS.widewrap, css.mainPage, 'qa-content')}>
        <div>
          <HeadText/>
          <div className={cs(sharedCSS.wideStretchable, sharedCSS.unpadded, sharedCSS.box)}>
            <SearchForm autoFocus={true} hasAction={true} isRevision={false} advanced={true}/>
          </div>

          <div className={cs(sharedCSS.wideStretchable, css.unpadded)}>
            <RecentSearches dashboard={true}/>
          </div>
          <div className={cs(sharedCSS.wideStretchable, css.unpadded)}>
            <CommandSwiper/>
          </div>

          <div className={cs(sharedCSS.wideStretchable, css.unpadded)}>
            <StateList />
          </div>
        </div>

        <div className={cs(sharedCSS.wideStretchable, css.catalogFooter)}>
          <a
            className={cs(css.footLink, css.active)}
            onClick={(e) => navigate(e, this.props)}
            href='/directions'
          >Directions</a>{' '}
          {/* <a className={css.footLink} onClick={(e) => navigate(e, this.props)} href='/brokers'>
            Brokers
          </a> */}
        </div>
            <UpgradeEntrance/>
      </div>
    );
  }
}

export default connect((state) => ({
  isLoggedIn: state.user.isLoggedIn ? state.user.isLoggedIn : false,
  emailPopSwitch: state.dots.mainSwitch.data.email_switch.switch,
  emailPopRate: state.dots.mainSwitch.data.email_switch.chance,
  user: state.user,
  accountLevel: state.account.accountLevel,
  free: state.account.free,
}), mapDispatch({
  login: () => modalChange(modes.LOGIN, 'dashboard'),
  signup: () => modalChange(modes.SIGNUP, 'dashboard'),
  validatePop: () => modalChange(modes.DOT_VALIDATE, 'dashboard'),
  showUpgradeToStandard: (props) => modalChange('pop', {
    source: 'dashboard',
    type: 'pop_upgrade_to_standard',
  }),
  showDownloadAppAndSendEmail: (props) => modalChange('pop', {
    source: 'dashboard',
    type: 'pop_download_and_send_verify_email',
  }),
  gotoBrokers: (props, href) => pushPath(href),
  gotoDirections: (props, href) => pushPath(href),
}))(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js